import React, { useEffect } from "react";
import "./WorkingProcess.scss";
import { useNavigate } from "react-router-dom";

// images
import Image1 from "../../assets/images/workprocess1.png";
import Image2 from "../../assets/images/workprocess2.png";
import Image3 from "../../assets/images/workprocess3.png";
import Image4 from "../../assets/images/workprocess4.png";

const timelineProcessSteps = [
  {
    number: 1,
    title: "Discussion & Brainstorming",
    image:Image1,
    content: `At EconSign Soft, we emphasize the importance of thorough discussions and brainstorming sessions to ensure the success of every project. Our brainstorming process is deeply rooted in software research, where we analyze the latest trends, tools, and technologies to identify the most effective solutions. During these sessions, our team collaborates to explore innovative ideas, evaluate feasibility, and align the proposed solutions with our clients' business objectives.`,
  },
  {
    number: 2,
    title: "Planning & Prototyping",
    image:Image2,
    content: `At EconSign Soft, meticulous planning and prototyping form the foundation of our development process. During the planning phase, we outline clear project goals, define timelines, allocate resources, and establish a roadmap to ensure seamless execution.`,
  },
  {
    number: 3,
    title: "Execution",
    image:Image3,
    content: `The execution phase at EconSign Soft is where plans and prototypes come to life. Our team of skilled developers and engineers leverages cutting-edge tools, technologies, and best practices to build robust and scalable software solutions.`,
  },
  {
    number: 4,
    title: "Delivery & Deployment",
    image:Image4,
    content: `At EconSign Soft, the Delivery & Deployment phase is the culmination of our development journey, where the final product is prepared for launch and handed over to the client.`,
  },
];

const WorkingProcess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const items = document.querySelectorAll(".timeline-row");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-card");
          }
        });
      },
      { threshold: 0.2 }
    );

    items.forEach((item) => observer.observe(item));
  }, []);

  return (
    <section className="timeline-process-section">
      <div className="timeline-header-container">
        <p className="timeline-subtitle">WORKING PROCESS</p>
        <h2 className="timeline-title">
          Our Working Process - How We Work For Our Clients
        </h2>
        <button
          className="timeline-header-button"
          onClick={() => navigate("/contact-us")}
        >
          Contact Us
        </button>
      </div>

      <div className="timeline-steps-container">
        {timelineProcessSteps.map((step, index) => {
          const isLeftCard = index % 2 === 0;

          return (
            <div
              key={step.number}
              className={`timeline-row hidden-card ${
                isLeftCard ? "left-card" : "right-card"
              }`}
            >
              {/* LEFT SIDE */}
              <div className="timeline-col">
                {isLeftCard ? (
                  <div className="timeline-card">
                    <h3>{step.title}</h3>
                    <p>{step.content}</p>
                  </div>
                ) : (
                  <img src={step.image} alt={step.title} />
                )}
              </div>

              {/* CENTER DOT */}
              <div className="timeline-center">
                <span>{step.number}</span>
              </div>

              {/* RIGHT SIDE */}
              <div className="timeline-col">
                {isLeftCard ? (
                  <img src={step.image} alt={step.title} />
                ) : (
                  <div className="timeline-card">
                    <h3>{step.title}</h3>
                    <p>{step.content}</p>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default WorkingProcess;
